module.exports = __webpack_public_path__ + "img/linkedin.ae9e1c7d.svg";